import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { SessionsArchive } from '../../../features/sessions/SessionsArchive';

/** Spec 8.2 `session.list` — the archive, folded with `session.results` into a heat board. */
export const Route = createFileRoute('/$lang/app/sessions/')({ component: Page });

function Page(): ReactNode {
  const { lang } = Route.useParams();
  return <SessionsArchive lang={lang} />;
}
